import { apiStage } from '@/plugins/axios'
import Service from '@/services/service'

/**
 * @type {Reports}
 */
export default class Reports extends Service {
	/**
	 * @param {Object} options
	 */
	constructor(options = {}) {
		super(options)
		this.http = apiStage
		this.resource = 'fastreports'
	}

	bytype(report, data) {
		return this.http.post(
			this.constructor.normalize(this.resource, this.constructor.normalize('bytype', report)),
			data,
		)
	}

	convert(data) {
		return this.http.post(this.constructor.normalize(this.resource, 'convert'), data)
	}

	search(jobId, data) {
		return this.http.post(
			this.constructor.normalize(this.resource, this.constructor.normalize('search', jobId)),
			data,
		)
	}

	/**
	 * @param {String} start
	 * @param {String} end
	 * @returns {String}
	 */
	static normalize(start, end) {
		return `${start}/${end}`.replace(/([^:]\/)\/+/g, '$1')
	}
}
